import { Permission } from "../../constants/enums";
import Strings from "../../constants/strings";

export const permissionData = [
    {
        name: Strings.Role.READ,
        code: Permission.Read,
    },
    {
        name: Strings.Role.READ_LIST,
        code: Permission.ListOrExport,
    },

    {
        name: Strings.Role.CREATE,
        code: Permission.Create,
    },
    {
        name: Strings.Role.BULK_CREATE,
        code: Permission.BulkCreateOrImport,
    },

    {
        name: Strings.Role.UPDATE,
        code: Permission.Update,
    },
    {
        name: Strings.Role.BULK_UPDATE,
        code: Permission.BulkUpdate,
    },
    {
        name: Strings.Role.DELETE,
        code: Permission.Delete,
    },
    {
        name: Strings.Role.BULK_DELETE,
        code: Permission.BulkDelete,
    },
];
